class CampaignService {
    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope) {
        return {

            saveFeatures: (campaignId, feedId, features) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'campaign/' + campaignId + '/update/features', { feedId: feedId, features: features }, {errorMessage: 'Failed to save features.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
             }

        };
    }

}

angular.module('cpm')
    .service('CampaignService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', CampaignService]);
